import React, { useContext, useEffect, useState } from 'react';
import SimpleFacetCheckbox from '../../global/components/inputs/selects/simple-facet-checkbox';
import PageContext from './../context/pageContext';
import { FiltersData } from './paginated-landing-content-app';

interface IProps {
    filtersData: FiltersData;
    updateRoleFacet: any;
    updateTopicFacet: any;
}

export default function PaginatedFilters(props: IProps) {
    const { topicFilter, setTopicFilter, roleFilter, setRoleFilter, ageFilter, setAgeFilter, contentTypeFilter, setContentTypeFilter, specialtyFilter, setSpecialtyFilter, activeFilter, setActiveFilter } = useContext(PageContext);
    const ExpandFiltersText = (window as any).bootstrap.ExpandFiltersText;
    const CollapseFiltersText = (window as any).bootstrap.CollapseFiltersText;
    const showRoleFilter = props.filtersData.showRoleFilter;
    const showTopicFilter = props.filtersData.showTopicFilter;
    const showAgeFilter = props.filtersData.showAgeRangesFilter;
    const showContentTypeFilters = props.filtersData.showContentTypeFilter;
    const showSpecialtyFilters = props.filtersData.showSpecialtyFilter;
    const defaultTopicSize = props.filtersData.defaultTopicFilterSize;
    const defaultRoleSize = props.filtersData.defaultRoleFilterSize;
    const defaultAgeSize = props.filtersData.defaultAgeRangesFilterSize;
    const defaultContentTypeSize = props.filtersData.defaultContentTypeFilterSize;
    const defaultSpecialtySize = props.filtersData.defaultSpecialtyFilterSize;
    const [roleFilterData, updateRoleFilterData] = useState([]);
    const [topicFilterData, updateTopicFilterData] = useState([]);
    const [ageFilterData, updateAgeFilterData] = useState([]);
    const [contentTypeFilterData, updateContentTypeFilterData] = useState([]);
    const [specialtyFilterData, updateSpecialtyFilterData] = useState([]);
    const [showAllTopics, setShowAllTopics] = useState(false);
    const [showAllRoles, setShowAllRoles] = useState(false);
    const [showAllAges, setShowAllAges] = useState(false);
    const [showAllContentTypes, setShowAllContentTypes] = useState(false);
    const [showAllSpecialties, setShowAllSpecialties] = useState(false);

    const updateTopicFilter = (filterName) => {
        let newTopicArray = [];
        let itemRemoved = false;
        topicFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }
            else {
                newTopicArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newTopicArray.push(filterName)
        }
        setTopicFilter(newTopicArray);
        
    }
    

    const updateRoleFilter = (filterName) => {
        let newRoleArray = [];
        let itemRemoved = false;
        roleFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }

            else {
                newRoleArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newRoleArray.push(filterName)
        }

        setRoleFilter(newRoleArray);
        
    }
    const updateAgeFilter = (filterName) => {
        let newAgeArray = [];
        let itemRemoved = false;
        ageFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }

            else {
                newAgeArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newAgeArray.push(filterName)
        }

        setAgeFilter(newAgeArray);

    }

    const updateContentTypeFilter = (filterName) => {
        let newContentTypeArray = [];
        let itemRemoved = false;
        contentTypeFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }

            else {
                newContentTypeArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newContentTypeArray.push(filterName)
        }

        setContentTypeFilter(newContentTypeArray);

    }

    const updateSpecialtyFilter = (filterName) => {
        let newSpecialtyArray = [];
        let itemRemoved = false;
        specialtyFilter.forEach(arrayItem => {
            if (arrayItem.id == filterName.id) {
                itemRemoved = true;
            }

            else {
                newSpecialtyArray.push(arrayItem)
            }
        })

        if (!itemRemoved) {
            newSpecialtyArray.push(filterName)
        }

        setSpecialtyFilter(newSpecialtyArray);

    }

    const checkForActiveFilter = () => {
        if (roleFilter.length > 0 || topicFilter.length > 0 || ageFilter.length > 0 || contentTypeFilter.length > 0 || specialtyFilter.length > 0) {
            setActiveFilter(true)
        }
        else {
            setActiveFilter(false)
        }
    }
    const updateTopicFacets = () => {
        const topicFilters = [];
        var visibleTopics = props.filtersData.topicFilters;
        if (visibleTopics && visibleTopics.length > defaultTopicSize && !showAllTopics) {
            visibleTopics = props.filtersData.topicFilters.slice(0, defaultTopicSize);
        }
        visibleTopics.forEach(item => {
            topicFilters.push({ id: item.key, value: item.value, name: item.key })
        });
        updateTopicFilterData(topicFilters);
    }

    const updateRoleFacets = () => {
        const roleFilters = [];
        var visibleRoles = props.filtersData.roleFilters;
        if (visibleRoles && visibleRoles.length > defaultRoleSize && !showAllRoles) {
            visibleRoles = props.filtersData.roleFilters.slice(0, defaultRoleSize);
        }
        visibleRoles.forEach(item => {;
            roleFilters.push({ id: item.key, value: item.value, name: item.key })
        });
        updateRoleFilterData(roleFilters);
    }
    const updateAgeFacets = () => {
        const ageFilters = [];
        var visibleAges = props.filtersData.ageRangesFilters;
        if (visibleAges && visibleAges.length > defaultAgeSize && !showAllAges) {
            visibleAges = props.filtersData.ageRangesFilters.slice(0, defaultAgeSize);
        }
        visibleAges.forEach(item => {
            ;
            ageFilters.push({ id: item.key, value: item.value, name: item.key })
        });
        updateAgeFilterData(ageFilters);
    }

    const updateContentTypeFacets = () => {
        const contentTypeFilters = [];
        var visibleContentTypes = props.filtersData.contentTypeFilters;
        if (visibleContentTypes && visibleContentTypes.length > defaultContentTypeSize && !showAllContentTypes) {
            visibleContentTypes = props.filtersData.contentTypeFilters.slice(0, defaultContentTypeSize);
        }
        visibleContentTypes.forEach(item => {
            contentTypeFilters.push({ id: item.key, value: item.value, name: item.key })
        });
        updateContentTypeFilterData(contentTypeFilters);
    }

    const updateSpecialtyFacets = () => {
        const specialtyFilters = [];
        var visibleSpecialties = props.filtersData.specialtyFilters;
        if (visibleSpecialties && visibleSpecialties.length > defaultSpecialtySize && !showAllSpecialties) {
            visibleSpecialties = props.filtersData.specialtyFilters.slice(0, defaultSpecialtySize);
        }
        visibleSpecialties.forEach(item => {
            specialtyFilters.push({ id: item.key, value: item.value, name: item.key })
        });
        updateSpecialtyFilterData(specialtyFilters);
    }

    useEffect(() => {
            checkForActiveFilter();
            updateRoleFacets();
        updateTopicFacets();
        updateAgeFacets();
        updateContentTypeFacets();
        updateSpecialtyFacets();
    }, [topicFilter, roleFilter, ageFilter, contentTypeFilter, specialtyFilter, showAllTopics, showAllRoles, showAllAges, showAllContentTypes, showAllSpecialties]);

    useEffect(() => {
        checkForActiveFilter();
        updateRoleFacets();
        updateTopicFacets();
        updateAgeFacets();
        updateContentTypeFacets();
        updateSpecialtyFacets();
    }, [props.filtersData.topicFilters, props.filtersData.roleFilters, props.filtersData.ageRangesFilters, props.filtersData.contentTypeFilters, props.filtersData.specialtyFilters]);

    const updateTopicFilterVisibility = () => {
        setShowAllTopics(!showAllTopics);
    }

    const updateRoleFilterVisibility = () => {
        setShowAllRoles(!showAllRoles);
    }
    const updateAgeFilterVisibility = () => {
        setShowAllAges(!showAllAges);
    }
    const updateContentTypeFilterVisibility = () => {
        setShowAllContentTypes(!showAllContentTypes);
    }
    const updateSpecialtyFilterVisibility = () => {
        setShowAllSpecialties(!showAllSpecialties);
    }

    return (

        <div className="paginated-filters-content" >

            {showTopicFilter &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.topicHeading}</div>
                    {topicFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateTopicFilter(item)}
                        />
                    )}
                    {props.filtersData.topicFilters.length > defaultTopicSize &&
                        <a href="javascript:void(0)" onClick={updateTopicFilterVisibility}>{showAllTopics ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                    
                </div>
            }
            {showRoleFilter &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.roleHeading}</div>
                    {roleFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateRoleFilter(item)}
                        />
                    )}
                    {props.filtersData.roleFilters.length > defaultRoleSize &&
                        <a href="javascript:void(0)" onClick={updateRoleFilterVisibility}>{showAllRoles ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                </div>
            }
            {showAgeFilter &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.ageRangesHeading}</div>
                    {ageFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateAgeFilter(item)}
                        />
                    )}
                    {props.filtersData.ageRangesFilters.length > defaultAgeSize &&
                        <a href="javascript:void(0)" onClick={updateAgeFilterVisibility}>{showAllAges ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                </div>
            }
            {showContentTypeFilters &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.contentTypeHeading}</div>
                    {contentTypeFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateContentTypeFilter(item)}
                        />
                    )}
                    {props.filtersData.contentTypeFilters.length > defaultContentTypeSize &&
                        <a href="javascript:void(0)" onClick={updateContentTypeFilterVisibility}>{showAllContentTypes ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                </div>
            }
            {showSpecialtyFilters &&
                <div className="paginated-facet-item">
                    <div className="h5-styled">{props.filtersData.specialtyHeading}</div>
                    {specialtyFilterData.map((item, i) =>
                        <SimpleFacetCheckbox
                            term={item.name}
                            showHits={true}
                            key={i}
                            id={item.name}
                            initialCount={item.value}
                            defaultChecked={false}
                            onTermClick={() => updateSpecialtyFilter(item)}
                        />
                    )}
                    {props.filtersData.specialtyFilters.length > defaultSpecialtySize &&
                        <a href="javascript:void(0)" onClick={updateSpecialtyFilterVisibility}>{showAllSpecialties ? CollapseFiltersText : ExpandFiltersText}</a>
                    }
                </div>
            }
        </div>

    );


}








